import {
  globalReleaseConstants,
  addGlobalReleaseConstants,
  editGlobalReleaseConstants,
} from "../_redux-constants";

export function globalReleaseReducer(
  state = {
    globalReleaseLoading: false,
    globalReleaseData: null,
    globalReleaseError: null,

    addGlobalReleaseLoading: false,
    addGlobalReleaseData: null,
    addGlobalReleaseError: null,

    editGlobalReleaseLoading: false,
    editGlobalReleaseData: null,
    editGlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case globalReleaseConstants.GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        globalReleaseLoading: true,
        globalReleaseData: null,
        globalReleaseError: null,
        addGlobalReleaseLoading: false,
        addGlobalReleaseData: null,
        addGlobalReleaseError: null,
      });
    case globalReleaseConstants.GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        globalReleaseLoading: false,
        globalReleaseData: action.data,
      });
    case globalReleaseConstants.GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        globalReleaseLoading: false,
        globalReleaseData: null,
        globalReleaseError: action.error,
      });
    case addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addGlobalReleaseLoading: true,
        addGlobalReleaseData: null,
        addGlobalReleaseError: null,
      });
    case addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addGlobalReleaseLoading: false,
        addGlobalReleaseData: action.data,
      });
    case addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addGlobalReleaseLoading: false,
        addGlobalReleaseData: null,
        addGlobalReleaseError: action.error,
      });
    case editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editGlobalReleaseLoading: true,
        editGlobalReleaseData: null,
        editGlobalReleaseError: null,
      });
    case editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editGlobalReleaseLoading: false,
        editGlobalReleaseData: action.data,
      });
    case editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editGlobalReleaseLoading: false,
        editGlobalReleaseData: null,
        editGlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
